<!-- <div class="messages" *ngIf="showOldStyle">
  <div class="message" (click)="showComment(item)" *ngFor="let item of messages">
  
    <div class="content" *ngIf="item.type === 2">
  
      <div class="message-content position-relative">
        <div class="message-body" [innerHTML]="item.content"></div>
  
      </div>
      <div class="message-footer">
        <span class="text-light ml-auto text-number timestamp">{{ item.timestamp }}</span>
      </div>
    </div>
    <div class="content" *ngIf="item.type !== 2">

      <div class="message-content position-relative">
        <div class="message-body text-light">
          <div class="message-body text-light">
            <span class="name-color">{{ item.user.name }}</span>
            在<span class="main-color title" title="{{ item.video.title }}">《{{ item.video.title }}》</span>回复了您的评论！
          </div>
        </div>
    
      </div>
      <div class="message-footer">
        <span class="text-light ml-auto text-number timestamp">{{ item.timestamp }}</span>
      </div>
    </div>
  </div>
</div> -->

<div class="messages d-flex justify-content-center align-items-center" style="height: 420px;">
  <div class="d-flex justify-content-center align-items-center"
    *ngIf="(!messages ||!messages.length) && !hasNewMessages">
    <h5 style="line-height: 43px" class="no-content">暂无内容</h5>
  </div>
  <div class="scroll-bar w-100" *ngIf="(messages && messages.length) || hasNewMessages" style="height: 100%;">
    <div class="message" [routerLink]="'/user/messages/chat'" [queryParams]="{id: item.id}"
      *ngFor="let item of concatsHasUnreadMessage.reverse()" (click)="markPrivateMessagesAsRead(item)">
      <div class="avatar">
        <img class="avatar-img mr-3" [src]="item.avatar">
        <img class="badge" [src]="_resourceService.getBadge(getMembership(item.gid))" *ngIf="!item.isOfficalUP && !item.isOfficalSpeaker" />
        <img class="badge" [src]="_resourceService.getBadge('bigV')" *ngIf="item.isOfficalUP && !item.isOfficalSpeaker" />
        <app-membership-icon *ngIf="item.isOfficalSpeaker"
          class="speaker-badge"
          [membership]="'speaker'"
          [noText]="true" [newIcon]="true">
        </app-membership-icon>
      </div>
      <div class="content">
        <div class="message-header">
          <div class="d-inline main-color">
            <span class="main-color">
              {{ item.name }}
            </span>
            给你发送了新的消息
          </div>
        </div>
        <div class="message-content position-relative">
          <div class="message-body" [innerHTML]="item.content"></div>
        </div>
        <div class="message-footer">
          <span class="text-light ml-auto text-number
                  timestamp">{{ item.lastMessage * 1000 | date:'yyyy-MM-ddTHH:mm:ss' | relativeTime}}</span>
        </div>
      </div>
    </div>
    <div *ngFor="let item of messages">
      <ng-container [ngSwitch]="item.actType">
        <div class="message" *ngSwitchCase="0">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="101">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  <span class="name-color" (click)="nameClick($event)">
                    <a [routerLink]="['/space/', item.uidStr ? item.uidStr : '']">
                      {{ item.nickName }}
                    </a>
                  </span>
                  在<span class="main-color title" title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>回复了您的评论！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="1">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您在<span class="main-color title" title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName
                    | slice:0:21)+'...':item.lidName}}》</span>的评论已获赞过十！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="2">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您在<span class="main-color title" title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName
                    | slice:0:21)+'...':item.lidName}}》</span>的评论已获赞过百！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="3">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您上传的<span class="main-color title"
                    title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>已获赞过十！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="4">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您上传的<span class="main-color title"
                    title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>已获赞过百！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="5">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您上传的<span class="main-color title"
                    title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>已获赞过千！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="message" *ngSwitchCase="7">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  恭喜！您上传的视频<span class="main-color title"
                    title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>已通过审核！金币+10！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="8">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  抱歉，您上传的视频<span class="main-color title"
                    title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>未通过审核~无金币奖励~
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="9">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您在<span class="main-color title" title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName
                    | slice:0:21)+'...':item.lidName}}》</span>发起的投票，已有十人参与！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="10">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您在<span class="main-color title" title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName
                    | slice:0:21)+'...':item.lidName}}》</span>发起的投票，已有百人参与！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="11">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您在<span class="main-color title" title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName
                    | slice:0:21)+'...':item.lidName}}》</span>发起的投票，已有千人参与！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="12">
          <div (click)="msgClick(item)" class="w-100 d-flex">
            <div class="avatar" *ngIf="item.headImg">
              <img class="avatar-img mr-3" [src]="item.headImg">
              <img class="badge" [src]="_resourceService.getBadge(getMembership(item.gid))" *ngIf="!item.isOfficalUP && !item.isOfficalSpeaker" />
              <img class="badge" [src]="_resourceService.getBadge('bigV')" *ngIf="item.isOfficalUP && !item.isOfficalSpeaker" />
              <app-membership-icon *ngIf="item.isOfficalSpeaker"
                class="speaker-badge"
                [membership]="'speaker'"
                [noText]="true" [newIcon]="true">
              </app-membership-icon>
            </div>
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  <span class="name-color">
                    <a [routerLink]="['/space/', item.uidStr ? item.uidStr : '']">
                      {{item.nickName}}
                    </a>
                  </span>
                  给你发送了新的消息
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="13">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="14">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="15">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="16">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="17">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="18">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="19">
          <div (click)="msgClick(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body">{{item.context}}</div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="message" *ngSwitchCase="21">
          <div (click)="item.cid === 8 ? navToActivity(item) : navToAlbum(item)" class="w-100">
            <div class="content">
              <div class="message-content position-relative">
                <div class="message-body text-light">
                  您发布的<span class="main-color title-2"
                    title="{{ item.lidName }}">《{{(item.lidName.length>22)?(item.lidName |
                    slice:0:21)+'...':item.lidName}}》</span>有新的评论！
                </div>
              </div>
              <div class="message-footer">
                <span class="text-light ml-auto text-number timestamp">{{item.addTime}}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>
</div>

<div class="dropdown-footer d-flex align-items-center">
  <div class="d-flex align-items-center jbutton jbutton-default"
    [ngClass]="{'disabled': (!messages?.length && !concatsHasUnreadMessage?.length)}"
    (click)="clearMessageNotifications()">
    <span class="iconfont iconshanchu"></span>
    <span>清空</span>
  </div>
  <a [routerLink]="['/user/messages']" [queryParams]="{type: 0}"
    class="d-flex align-items-center jbutton jbutton-default ml-auto">
    <span>消息中心</span>
    <span class="iconfont iconchakangengduo fs-16"></span>
  </a>
</div>